import CustomSelect from "../plugins/custom-select.js";

new CustomSelect('.year-copy-image_select__wrapper', '.year-copy-image_select__title', '.year-copy-image_select__options')
